import React, { useState, useEffect, useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import AxiosInstance from "../AxiosInstance";
import ToastNotification from "../ToastNotification";

const EmployeeRemarksModal = ({ show, onHide, remarkData, onSave, remarkTopics, userId }) => {
  const toastRef = useRef();
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [file, setFile] = useState(null);
  const [date, setDate] = useState("");
  const [remarkTopic, setRemarkTopic] = useState("");

  // Reset form when modal is opened
  useEffect(() => {
    if (show && remarkData) {
      setTitle(remarkData.title || "");
      setDescription(remarkData.description || "");
      setDate(remarkData.date ? remarkData.date.substring(0, 10) : "");
      // Find the matching topic based on the remark_topic string
      const matchedTopic = remarkTopics.find(topic => topic.remark_reason === remarkData.remark_topic);
      setRemarkTopic(matchedTopic ? matchedTopic.id : "");  // Set the ID of the matching topic
    } else {
      const today = new Date().toISOString().split("T")[0];
      setTitle("");
      setDescription("");
      setDate(today);
      setFile(null);
      setRemarkTopic(""); // Reset for "Add" mode
    }
  }, [show, remarkData, remarkTopics]);     

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSave = async () => {
    if (!userId) {
      toastRef.current?.showToast("User not found. Please login again.", "danger");
      return;
    }

    if (!title || !description || !date || !remarkTopic) {
      toastRef.current.showToast("All fields including Type are required.", "danger");
      return;
    }

    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("date", date);
    formData.append("type", remarkTopic);
    if (file) formData.append("file", file);

    try {
      if (remarkData && remarkData.id) {
        await AxiosInstance.put(`/admin/update-remark/${remarkData.id}`, formData);
      } else {
        await AxiosInstance.post(`/admin/upload-remark/${userId}`, formData);
      }

      toastRef.current.showToast("Remark saved successfully!", "success");
      onSave();
      onHide();
    } catch (error) {
      toastRef.current.showToast("Failed to save remark. Try again.", "danger");
    }
  };

  return (
    <>
      <Modal show={show} onHide={onHide}>
        <Modal.Header closeButton>
          <Modal.Title>{remarkData ? "Update Remark" : "Add Remark"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label">Type</label>
            <select
              className="form-select"
              value={remarkTopic} 
              onChange={(e) => setRemarkTopic(e.target.value)}
            >
              <option value="">-- Select a Type --</option>
              {remarkTopics.map((topic) => (
                <option key={topic.id} value={topic.id}>
                  {topic.remark_reason}
                </option>
              ))}
            </select>
          </div>
          <div className="mb-3">
            <label className="form-label">Title</label>
            <input
              type="text"
              className="form-control"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Description</label>
            <textarea
              className="form-control"
              rows="3"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Date</label>
            <input
              type="date"
              className="form-control"
              value={date}
              onChange={(e) => setDate(e.target.value)}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Attachment</label>
            <input
              type="file"
              className="form-control"
              onChange={handleFileChange}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSave}>
            {remarkData ? "Update" : "Add"} Remark
          </Button>
        </Modal.Footer>
      </Modal>
      <ToastNotification ref={toastRef} />
    </>
  );
};

export default EmployeeRemarksModal;
